import { configure, defineRule } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import { required, max, length, alpha_dash, numeric } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";

/**
 * 資材発注登録画面の入力検証設定を初期化する composable。
 */
export const useFixturesRegisterValidation = () => {
  defineRule("required", required);
  defineRule("max", max);
  defineRule("length", length);
  defineRule("alpha_dash", alpha_dash);
  defineRule("numeric", numeric);
  configure({
    generateMessage: localize({
      ja,
    }),
  });
  localize("ja");
};
